module.exports = __webpack_public_path__ + "img/download-icon.0ffb3515.svg";